// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-btn {
  width: 160px;
  height: 40px;
}

.primary-btn {
  background: linear-gradient(305.75deg, #92278f -144.06%, #ec7765 147.18%);
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  border-radius: 6px;
}
.primary-btn.disabled-btn {
  opacity: 0.7;
}

.secondary-btn {
  background: #eee;
  color: #000;
  font-size: 14px;
  font-weight: 400;
  border-radius: 6px;
}
.secondary-btn.disabled-btn {
  opacity: 0.7;
}`, "",{"version":3,"sources":["webpack://./src/components/CustomButton/style.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,YAAA;AACF;;AAEA;EACE,yEAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AACF;AAKE;EACE,YAAA;AAHJ;;AAUA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAPF;AASE;EACE,YAAA;AAPJ","sourcesContent":[".custom-btn {\n  width: 160px;\n  height: 40px;\n}\n\n.primary-btn {\n  background: linear-gradient(305.75deg, #92278f -144.06%, #ec7765 147.18%);\n  color: #fff;\n  font-size: 14px;\n  font-weight: 400;\n  border-radius: 6px;\n\n  // &:hover {\n  //   background: #b63f48;\n  // }\n\n  &.disabled-btn {\n    opacity: 0.7;\n    // &:hover {\n    //   background: linear-gradient(305.75deg, #92278f -144.06%, #ec7765 147.18%);\n    // }\n  }\n}\n\n.secondary-btn {\n  background: #eee;\n  color: #000;\n  font-size: 14px;\n  font-weight: 400;\n  border-radius: 6px;\n  \n  &.disabled-btn {\n    opacity: 0.7;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
